import {
  FlashIcon,
  Link02Icon,
  MessageAdd01Icon,
  MessageDone01Icon,
  Refresh01Icon,
  Tag02Icon,
  TiktokIcon,
  UserEdit01Icon,
  WebhookIcon,
  ZapIcon,
} from '@hugeicons/core-free-icons';

const DEFAULT_EVENT_VISUAL = {
  hugeIcon: FlashIcon,
  iconClass: 'text-n-slate-11',
};

/** @type {Record<string, Partial<typeof DEFAULT_EVENT_VISUAL>>} */
const WORKFLOW_EVENT_VISUAL = {
  conversation_opened: {
    hugeIcon: MessageAdd01Icon,
    iconClass: 'text-n-cyan-10',
  },
  conversation_closed: {
    hugeIcon: MessageDone01Icon,
    iconClass: 'text-n-cyan-10',
  },
  contact_field_updated: {
    hugeIcon: UserEdit01Icon,
    iconClass: 'text-n-iris-10',
  },
  contact_tag_updated: {
    hugeIcon: Tag02Icon,
    iconClass: 'text-n-iris-10',
  },
  manual: {
    hugeIcon: ZapIcon,
    iconClass: 'text-n-amber-10',
  },
  incoming_webhook: {
    hugeIcon: WebhookIcon,
    iconClass: 'text-n-teal-10',
  },
  click_to_chat_ad: {
    hugeIcon: Link02Icon,
    iconClass: 'text-n-blue-10',
  },
  tiktok_messaging_ad: {
    hugeIcon: TiktokIcon,
    iconClass: 'text-n-slate-12',
  },
  lifecycle_updated: {
    hugeIcon: Refresh01Icon,
    iconClass: 'text-n-slate-11',
  },
};

/**
 * @param {string} [eventKey]
 */
export function getWorkflowEventVisual(eventKey) {
  return {
    ...DEFAULT_EVENT_VISUAL,
    ...(eventKey ? WORKFLOW_EVENT_VISUAL[eventKey] : {}),
  };
}

/**
 * @param {Array<{ key: string, value: string }>} events
 */
export function buildWorkflowEventSelectOptions(events) {
  return events.map(({ key, value: label }) => {
    const visual = getWorkflowEventVisual(key);
    return {
      key,
      label,
      icon: visual.hugeIcon,
      iconClass: visual.iconClass,
    };
  });
}
